import React from "react";
import {useState,useEffect,useRef } from 'react';
import { LineChart,BarChart,AreaChart,Rectangle,Bar, Line,Area, XAxis, YAxis, CartesianGrid, Tooltip, 
  Legend, ResponsiveContainer, Cell, ReferenceLine, PieChart,Pie,LabelList } from "recharts";
import axios from "axios";
import configData from "../config.json";
import {Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { useReactToPrint } from 'react-to-print';
import { monthList } from '../utils/datalist';
import GrowthChart from '../components/GrowthChart';
import { COLOR } from "rsuite/esm/internals/constants";


const BsecDashboard=()=>{
      const [misData,setMisData]=useState([]);
      const [misDataSum,setMisDataSum]=useState([]);
      const [aMonth, setMonth] = useState(6);
      const [aYear, setYear] = useState(2025);
      const [loading, setLoading] = useState(false);
      const [activeCell,setActiveCell]=useState("");

      const COLORS = ['#FFBB28', '#FF8042','#f02390ff','#0b9118ff','#0088FE', '#00C49F' ];

    useEffect(() => {
      const getMisData = async () => {
        const response=await axios.get(configData.SERVER_URL+`/bsecmisDashboard/${localStorage.getItem('branchID')}`)
        setMisData(response.data);
      };
      getMisData();

    }, []);

    const handleSubmit=async(e)=>{
      e.preventDefault();
      setLoading(true);
      try {
        const response = await axios.get(configData.SERVER_URL+`/misDataSum/${aYear}/${aMonth}/${localStorage.getItem('branchID')}`);
        setMisDataSum(response.data);
      } catch (error) {
        console.error('Search error:', error);
      }   
      setLoading(false);
    }

    const totals = misDataSum.reduce((acc, item) => {
      
      acc.monthlyProValue += Number(item.proValue) || 0;
      acc.totalCumProValue += Number(item.cumProValue) || 0;
      acc.totalCumPreProValue += Number(item.cumPreProValue) || 0;

      acc.monthlySalesValue += Number(item.salesValue) || 0;
      acc.totalCumSalesValue += Number(item.cumSalesValue) || 0;
      acc.totalCumPreSalesValue += Number(item.cumPreSalesValue) || 0;

      acc.monthlyProfitLoss += Number(item.profitLoss) || 0;
      acc.totalCumProfitLoss += Number(item.cumProfitLoss) || 0;
      acc.totalCumPreProfitLoss += Number(item.cumPreProfitLoss) || 0;
      return acc;
    },
    { monthlyProValue:0, totalCumProValue: 0, totalCumPreProValue: 0, 
      monthlySalesValue:0, totalCumSalesValue: 0, totalCumPreSalesValue: 0,
      monthlyProfitLoss:0, totalCumProfitLoss: 0, totalCumPreProfitLoss: 0,
     }
    );
    
    const getMonthName = (id) => {
      return monthList.find(m => m.id === Number(id))?.name || "not";
    };

     const printDiv_ProfitLoss = () => {
      const printElement = document.getElementById('print_profit_loss');

      if (!printElement) {
      console.error("Print div not found:");
      return;
      }

    const printContent = printElement.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

    const printDiv_ProfitLoss_Graph = () => {
      const printElement = document.getElementById('print_profit_loss_Graph');

      if (!printElement) {
      console.error("Print div not found:");
      return;
      }

    const printContent = printElement.innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

   

    const printDiv_sales = () => {

    const printContent = document.getElementById('print_sales').innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

    const printDiv_sales_Graph = () => {

    const printContent = document.getElementById('print_sales_Graph').innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

    const printDiv_production = () => {

    const printContent = document.getElementById('print_production').innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

    const printDiv_production_Graph = () => {

    const printContent = document.getElementById('print_production_Graph').innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

    const printDiv_PLGraph = () => {

    const printContent = document.getElementById('print_PL_graph').innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
    };

  const getProfitComment = (curr, prev, diff) => {

  // Profit → Profit
  if (prev > 0 && curr > 0) {
    return curr > prev? 'Profit Increased': 'Profit Decreased';
  }

  // Loss → Profit (Turnaround)
  if (prev < 0 && curr > 0) {
    return 'Excellent Turnaround From Loss to Profit';
  }

  // Profit → Loss (Negative Turnaround)
  if (prev > 0 && curr < 0) {
    return 'Strong Negative Turnaround From Profit to Loss';
  }

  // Loss → Loss
  if (prev < 0 && curr < 0) {
    return diff < 0 ? `Loss Increased`: `Loss Decreased`;
  }

  return 'No Comments';
  };

    return(
        <>
        <div  style={{marginTop:50, marginBottom:50}}>
            {/* <div className="card card-body py-5">
                <div className="col-xl-12 col-sm-12 mb-3">
                  <div className="card  bg-warning o-hidden h-100" id="print_PL_graph">
                    <div className="card-title">Monthly Profit/Loss (Amount In Lac)</div>
                    <div className="card-header">
                          <button type="button" class="btn btn-info" style={{borderRadius:'30px'}}>
                          <span onClick={printDiv_PLGraph}><Icon.Printer/></span>              
                          </button>
                    </div>
                    <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>

                      <ResponsiveContainer width="100%" height={200}>
                        <BarChart data={misData || []} fontSize={10}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="branchcode" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="profitLoss" name="Profit/Loss" label={{ position: "top" }}
                            activeBar={<Rectangle  stroke="red" />}>
                          {(misData || []).map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.profitLoss < 0 ? "red" : "green"}/>
                          ))}
                        </Bar>
                        </BarChart>
                      </ResponsiveContainer>

                    </div>
  
                  </div>
                </div>
            </div>                      */}
            
            <div className="card text-black bg-info o-hidden h-100">
                <div className="card-header">
                  {/* {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                  </>
                  ) : (
                    "Monthly MIS Data Analysis"
                  )} */}

                  <div className="row well">
            <h2 style={{ margin: 0 }}>
              Sales, Production & Profit Analysis
            </h2>

            <small style={{ color: "#6c757d" }}>
              Current Year vs Previous Year with Cumulative Data
            </small>
          </div>

                  <div className="row well">
                    <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                      <label>Financial Year</label>
                      <input type="number" class="form-control" id="aYear" name="aYear" value={aYear} onChange={(e)=>{setYear(e.target.value);}}></input>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                      <label>Month</label>
                      <select className="form-select col-lg-2 col-md-4 col-xs-6" id="monthName" name="monthName" onChange={(e)=>{setMonth(e.target.value);}}  value={aMonth} required>
                      {monthList.map(month => (
                        <option key={month.id} value={month.id}>{month.name}</option>
                      ))}   
                      </select>
                    </div>
                    <div className="col-lg-2">
                      <br></br>
                      <button type="button" class="btn btn-success">
                          <span onClick={(e)=>{handleSubmit(e)}}><Icon.Search/></span>
                      </button>
                      <button type="button" class="btn btn-warning" >
                          <span onClick={printDiv_production}><Icon.Printer/></span>              
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "0px", borderRadius: "10px" }}>
                  {
                    misDataSum && misDataSum.length >0 &&(
                      <>
                      <div className="card text-white bg-info o-hidden h-100" id="print_production" >
                        {/* <h4 className="text-center mb-4">Production, Sales & Profit-Loss</h4>  */}                       
                        <div className="card-header">
                          
                        </div>
                        <div className="card-body"  style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>
                        <div className="table-responsive table-container"  >
                        <table className="table table-bordered table-hover align-middle text-center  mis-table" style={{fontSize:'14px'}}>
                        <thead className="table-primary">
                          <tr>
                            <th rowSpan={2}>Org Name</th>
                            <th rowSpan={2}>Particulars</th>
                            <th colspan={2} className="align-top">Target (Qty/Value)</th> 
                            <th colspan={4} className="align-top">Financial Year {aYear}-{Number(aYear)+1} (For the month {getMonthName(aMonth)},{ aMonth>=6 ? aYear : aYear+1})</th>
                            <th colspan={3} className="align-top" style={{backgroundColor:'pink',fontSize:'12px'}} >Financial Year {Number(aYear)-1}-{Number(aYear)}<br></br>(For the month {getMonthName(aMonth)},{ aMonth>=6 ? aYear : aYear})</th> 
                            <th rowSpan={2}>Difference<br></br>Qty/Value</th>
                            <th rowSpan={2}>Growth (% on Value)</th>
                          </tr>
                          <tr>  
                            <th>Month Target<br></br>Qty/Value</th>
                            <th>Cum.<br></br>Qty/Value</th>

                            <th>Current Month<br></br>Qty/Value</th>
                            <th>Cum.<br></br>Qty/Value</th>
                            <th>Monthly<br></br> Achi.(Qty)</th>
                            <th>Cum.<br></br> Achi.(Qty)</th>

                            <th>Target<br></br>Qty/Value</th>
                            <th>Cum.<br></br>Qty/Value</th>
                            <th>Achie. (Qty)</th>
                            </tr>  
                        </thead>
                        <tbody>
                          {                            
                          misDataSum && misDataSum.length>0 && misDataSum.map((data,index)=>(
                            <React.Fragment key={index}>
                            <tr style={{border:2}}>
                              <td rowSpan={3} >{data.branchcode}<br></br><Link to= {"/misReport/"+data.branchID+"/"+data.fYear} ><Icon.EyeFill size={20}/></Link></td>
                              <td>Production</td>
                              <td>{Number(data.proMtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.proMtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.cumProMtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.cumProMtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{data.proQty!== null ? Number(data.proQty):'0.00'}<hr></hr>{data.proValue!== null ? Number(data.proValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{Number(data.cumProQty)}<hr></hr>{data.cumProValue!== null ? Number(data.cumProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{(data.proQty>0 && data.proMtQty>0) ? ((Number(data.proQty)/Number(data.proMtQty))*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              <td>{(data.cumProQty>0 && data.cumProMtQty) ? ((Number(data.cumProQty)/Number(data.cumProMtQty))*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              
                              <td style={{backgroundColor:'pink'}}>{Number(data.preProTargetQty)}<hr></hr>{data.preProTargetValue!== null ? Number(data.preProTargetValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{Number(data.cumPreProQty)}<hr></hr>{data.cumPreProValue!== null ? Number(data.cumPreProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{(data.cumPreProQty>0 && data.preProTargetQty>0) ? Number((data.cumPreProQty/((data.preProTargetQty/12)*data.fMonth))*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              
                              <td>{(data.cumProQty-data.cumPreProQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.diffProductionGrowth).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.productionGrowth).toFixed(2).toLocaleString('en-IN')} % {(data.diffProductionGrowth>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                            </tr>

                            <tr style={{border:2}}>                             
                              <td>Sales</td>
                              <td>{Number(data.mtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.mtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.cumMtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.cumMtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{data.salesQty!== null ? Number(data.salesQty):'0.00'}<hr></hr>{data.salesValue!== null ? Number(data.salesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{Number(data.cumSalesQty)}<hr></hr>{data.cumSalesValue!== null ? Number(data.cumSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{(data.salesQty>0 && data.mtQty>0) ? Number((data.salesQty/data.mtQty)*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              <td>{(data.cumSalesQty>0 && data.cumMtQty) ? Number((data.cumSalesQty/data.cumMtQty)*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              
                              <td style={{backgroundColor:'pink'}}>{Number(data.preTargetQty)}<hr></hr>{data.preTargetValue!== null ? Number(data.preTargetValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{Number(data.cumPreSalesQty)}<hr></hr>{data.cumPreSalesValue!== null ? Number(data.cumPreSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{(data.preTargetQty>0 && data.cumPreSalesQty>0) ? Number((data.cumPreSalesQty/((data.preTargetQty/12)*data.fMonth))*100).toFixed(2):'0'} % </td>
                              
                              <td>{Number(data.cumSalesQty-data.cumPreSalesQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.diffSalesGrowth).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.salesGrowth).toFixed(2).toLocaleString('en-IN')} %{(data.diffSalesGrowth>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                            </tr>

                            <tr style={{border:2}}>                           
                              <td>Profit/Loss</td>
                              <td>0</td>
                              <td>0</td>
                              <td>{data.profitLoss!== null ? data.profitLoss:'0.00'}</td>
                              <td>{data.cumProfitLoss!== null ? data.cumProfitLoss:'0.00'}</td>
                              <td>0</td>
                              <td>0</td>

                              <td style={{backgroundColor:'pink'}}>0</td>
                              <td style={{backgroundColor:'pink'}}>{data.cumPreProfitLoss!== null ? Number(data.cumPreProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>0</td>
 
                              <td>{Number(data.diffProfitGrowth).toFixed(2).toLocaleString('en-IN')}</td>
                              
                              <td>
                                {Number(data.profitGrowth).toFixed(2).toLocaleString('en-IN')} %
                                {(data.diffProfitGrowth>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}
                                <br></br>
                                {getProfitComment(data.cumProfitLoss, data.cumPreProfitLoss,data.diffProfitGrowth)}
                              </td>
                            </tr>

                            <tr><td colspan={13} style={{backgroundColor:'lightgreen'}}></td></tr>
                            </React.Fragment>
                          ))}
                          <tr style={{border:2}}>
                            <td rowSpan={3} >Total:</td>
                            <td>Production</td>
                            <td>0</td>
                            <td>0</td>
                            <td>{Number(totals.monthlyProValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalCumProValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>0</td>
                            <td>0</td>
                            <td style={{backgroundColor:'pink'}}>0</td>
                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalCumPreProValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>0</td>
                            <td>{Number(totals.totalCumProValue-totals.totalCumPreProValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{(Number(totals.totalCumProValue-totals.totalCumPreProValue)>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                          </tr>
                          
                          <tr style={{border:2}}>
                            <td>Sales</td>
                            <td>0</td>
                            <td>0</td>
                            <td>{Number(totals.monthlySalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalCumSalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>0</td>
                            <td>0</td>
                            <td style={{backgroundColor:'pink'}}>0</td>
                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalCumPreSalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>0</td>
                            <td>{Number(totals.totalCumSalesValue-totals.totalCumPreSalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{(Number(totals.totalCumSalesValue-totals.totalCumPreSalesValue)>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                          </tr>

                          <tr style={{border:2}}>
                            <td>Profit/Loss</td>
                            <td>0</td>
                            <td>0</td>
                            <td>{Number(totals.monthlyProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalCumProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>0</td>
                            <td>0</td>
                            <td style={{backgroundColor:'pink'}}>0</td>
                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalCumPreProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>0</td>
                            <td>{Number(totals.totalCumProfitLoss-totals.totalCumPreProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{(Number(totals.totalCumProfitLoss-totals.totalCumPreProfitLoss)>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                          </tr>
                          <tr><td colspan={13} style={{backgroundColor:'lightgreen'}}></td></tr>
                        </tbody>
                        <tfoot>
                          
                        </tfoot>
                        </table>
                        
                        </div>
                        </div>
                      </div> 
                      </>
                    )
                  }                  
                  
                </div>  
            </div>                   
        </div>
        </>
    )
}

export default BsecDashboard;